import React from 'react'
import * as Styled from './Proposition.styles'
import { AssemblyIcon, GuaranteeIcon } from './PropositionIcons'

const Proposition = ({ icon, heading, description, noBorderTop }) => {
  const hasPropositionInformation = icon || heading || description
  if (!hasPropositionInformation) return null

  const icons = {
    GuaranteeIcon: <GuaranteeIcon />,
    AssemblyIcon: <AssemblyIcon />
  }

  return (
    <Styled.Container noBorderTop={noBorderTop} data-test='proposition-component'>
      {icon ? (
        <Styled.IconColumn data-test='proposition-icon-column'>{icons[icon]}</Styled.IconColumn>
      ) : (
        <Styled.IconColumn data-test='proposition-icon-column' />
      )}
      {heading && (
        <Styled.HeadingColumn data-test='proposition-heading-column'>
          <Styled.Heading>{heading}</Styled.Heading>
        </Styled.HeadingColumn>
      )}
      {description && (
        <Styled.DescriptionColumn data-test='proposition-description-column'>
          <p>{description}</p>
        </Styled.DescriptionColumn>
      )}
    </Styled.Container>
  )
}

export default Proposition
